import { styled } from "@mui/material/styles";

const styledName = "ForgotPasswordForm";

export const StyledInputWrapper = styled("div", {
  name: styledName,
})({
  "&": {
    marginTop: "60px",
    marginBottom: "30px",
  },
});
